import Vue from "vue";
import Chartist from "vue-chartist";

require("chartist-plugin-legend");

Vue.use(Chartist);

export default new Vue();
